if (!customElements.get('theme-announcement-bar')) {
  customElements.define('theme-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.messages = Array.from(this.querySelectorAll('[data-announcement-message]'));
      this.index = Math.max(0, this.messages.findIndex(message => message.classList.contains('is-active')));
      this.hovered = false;
      this.focused = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.status = this.querySelector('.theme-announcement__status');

      this.querySelector('[data-announcement-prev]')?.addEventListener('click', () => this.show(this.index - 1, true), options);
      this.querySelector('[data-announcement-next]')?.addEventListener('click', () => this.show(this.index + 1, true), options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      window.addEventListener('resize', () => this.measure(), options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.measure();
      this.schedule();
    }

    measure() {
      document.documentElement.style.setProperty('--theme-announcement-height', `${this.offsetHeight}px`);
      document.documentElement.classList.add('has-theme-announcement');
    }

    show(index, manual = false) {
      if (!this.messages.length) return;
      this.index = (index + this.messages.length) % this.messages.length;
      this.messages.forEach((message, position) => {
        const active = position === this.index;
        message.classList.toggle('is-active', active);
        message.setAttribute('aria-hidden', String(!active));
      });
      if (manual && this.status) this.status.textContent = this.messages[this.index].textContent;
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.timer);
      if (this.messages.length < 2 || this.hovered || this.focused || document.hidden || this.motion.matches) return;
      this.timer = window.setTimeout(() => this.show(this.index + 1), this.interval);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      document.documentElement.classList.remove('has-theme-announcement');
      document.documentElement.style.removeProperty('--theme-announcement-height');
    }
  });
}
